export default __webpack_public_path__ + "static/media/tg.16d95b6d.png";